
import React, { useState, useEffect, useMemo } from 'react';

import NavigationBar from '../navbar/NavigationBar';

import Footer from '../navbar/Footer';

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  styled,
  Chip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Pagination,
  Grid,
  TextField,
  Button,
  IconButton,
  Tooltip,
  Collapse,
  Alert
} from '@mui/material';

import SearchIcon from '@mui/icons-material/Search';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import InfoIcon from '@mui/icons-material/Info';
import { Height } from '@mui/icons-material';

const HeaderCell = styled(TableCell)(({ theme }) => ({
  backgroundColor: '#439506',
  color: theme.palette.common.white,
  fontWeight: 'bold',
  fontSize: '0.875rem',
  position: 'sticky',
  top: 0,
  zIndex: 1,
}));

const PastDeadlineChip = styled(Chip)({
  backgroundColor: '#ffebee',
  color: '#c62828',
});

const UpcomingDeadlineChip = styled(Chip)({
  backgroundColor: '#e8f5e9',
  color: '#2e7d32',
});
const CurrentMonthChip = styled(Chip)({
  backgroundColor: '#bbdefb',
  color: '#0d47a1',
  fontWeight: 'bold',
});

const CalendarTable = () => {
  const data = [
    
    {
      "month": "Décembre 2027",
      "year": "2027",
      "publications": [
        {
          "name": "Indice des prix à la consommation (Taux d'inflation) Novembre 2027",
          "period": "Mensuelle",
          "deadline": "15/12/2027"
        },
        {
          "name": "Indice des prix à la production agricole Novembre 2027",
          "period": "Mensuelle",
          "deadline": "15/12/2027"
        },
        {
          "name": "Indice du coût de construction de logements neufs au Burundi Novembre 2027",
          "period": "Mensuelle",
          "deadline": "15/12/2027"
        },
          {
          "name": "Les comptes nationaux trimestriels Troisieme trimestre 2027",
          "period": "Trimestrielle",
          "deadline": "31/12/2027"
        }
      ]
    },
    {
      "month": "Novembre 2027",
      "year": "2027",
      "publications": [
        {
          "name": "Indice des prix à la consommation (Taux d'inflation) Octobre 2027",
          "period": "Mensuelle",
          "deadline": "15/11/2027"
        },
        {
          "name": "Indice harmonisé à la production (IHPI) Troisieme trimestre 2027",
          "period": "Trimestrielle",
          "deadline": "15/11/2027"
        },
        {
          "name": "Indice du commerce extérieur (ICE) Troisieme trimestre 2027",
          "period": "Trimestrielle",
          "deadline": "15/11/2027"
        },
        {
          "name": "Indice du chiffre d'affaire (ICA) Troisieme trimestre 2027",
          "period": "Trimestrielle",
          "deadline": "15/11/2027"
        },
       
        {
          "name": "Bulletin du commerce extérieur Troisieme trimestre 2027",
          "period": "Trimestrielle",
          "deadline": "15/11/2027"
        },
        {
          "name": "Bulletin de conjoncture Troisieme trimestre 2027",
          "period": "Trimestrielle",
          "deadline": "15/11/2027"
        },
        {
          "name": "Note de conjoncture Troisieme trimestre 2027",
          "period": "Trimestrielle",
          "deadline": "15/11/2027"
        },
        {
          "name": "Referentiel (mercuriale) des prix au Burundi Troisieme trimestre 2027",
          "period": "Trimestrielle",
          "deadline": "15/11/2027"
        },
        {
          "name": "NewsStat Troisieme trimestre 2027",
          "period": "Trimestrielle",
          "deadline": "15/11/2027"
        },
        {
          "name": "Indice des prix à la production agricole Octobre 2027",
          "period": "Mensuelle",
          "deadline": "15/11/2027"
        },
        {
          "name": "Indice du coût de construction de logements neufs au Burundi Octobre 2027",
          "period": "Mensuelle",
          "deadline": "15/11/2027"
        }
      ]
    },
    {
      "month": "Octobre 2027",
      "year": "2027",
      "publications": [
        {
          "name": "Indice des prix à la consommation (Taux d'inflation) Septembre 2027",
          "period": "Mensuelle",
          "deadline": "15/10/2027"
        },
        {
          "name": "Indice des prix à la production agricole Septembre 2027",
          "period": "Mensuelle",
          "deadline": "15/10/2027"
        },
        {
          "name": "Indice du coût de construction de logements neufs au Burundi Septembre 2027",
          "period": "Mensuelle",
          "deadline": "15/10/2027"
        }
      ]
    },
    {
      "month": "Septembre 2027",
      "year": "2027",
      "publications": [
        {
          "name": "Indice des prix à la consommation (Taux d'inflation) Aout 2027",
          "period": "Mensuelle",
          "deadline": "15/09/2027"
        },
        {
          "name": "Indice des prix à la production agricole Aout 2027",
          "period": "Mensuelle",
          "deadline": "15/09/2027"
        },
        {
          "name": "Indice du coût de construction de logements neufs au Burundi Aout 2027",
          "period": "Mensuelle",
          "deadline": "15/09/2027"
        },
        
        {
          "name": "Les comptes nationaux trimestriels Deuxieme trimestre 2027",
          "period": "Trimestrielle",
          "deadline": "30/09/2027"
        }
      ]
    },
    {
      "month": "Août 2027",
      "year": "2027",
      "publications": [
        {
          "name": "Indice des prix à la consommation (Taux d'inflation) Juillet 2027",
          "period": "Mensuelle",
          "deadline": "15/08/2027"
        },
        {
          "name": "Indice harmonisé à la production (IHPI) Deuxieme trimestre 2027",
          "period": "Trimestrielle",
          "deadline": "15/08/2027"
        },
        {
          "name": "Indice du commerce extérieur (ICE) Deuxieme trimestre 2027",
          "period": "Trimestrielle",
          "deadline": "15/08/2027"
        },
        {
          "name": "Indice du chiffre d'affaire (ICA) Deuxieme trimestre 2027",
          "period": "Trimestrielle",
          "deadline": "15/08/2027"
        },
        {
          "name": "Bulletin du commerce extérieur Deuxieme trimestre 2027",
          "period": "Trimestrielle",
          "deadline": "15/08/2027"
        },
        {
          "name": "Bulletin de conjoncture Deuxieme trimestre 2027",
          "period": "Trimestrielle",
          "deadline": "15/08/2027"
        },
        {
          "name": "Note de conjoncture Deuxieme trimestre 2027",
          "period": "Trimestrielle",
          "deadline": "15/08/2027"
        },
        {
          "name": "Referentiel (mercuriale) des prix au Burundi Deuxieme trimestre 2027",
          "period": "Trimestrielle",
          "deadline": "15/08/2027"
        },
        {
          "name": "NewsStat Deuxieme trimestre 2027",
          "period": "Trimestrielle",
          "deadline": "15/08/2027"
        },
        {
          "name": "Indice des prix à la production agricole Juillet 2027",
          "period": "Mensuelle",
          "deadline": "15/08/2027"
        },
        {
          "name": "Indice du coût de construction de logements neufs au Burundi Juillet 2027",
          "period": "Mensuelle",
          "deadline": "15/08/2027"
        }
      ]
    },
    {
      "month": "Juillet 2027",
      "year": "2027",
      "publications": [
        {
          "name": "Indice des prix à la consommation (Taux d'inflation) Juin 2027",
          "period": "Mensuelle",
          "deadline": "15/07/2027"
        },
        {
          "name": "Indice des prix à la production agricole Juin 2027",
          "period": "Mensuelle",
          "deadline": "15/07/2027"
        },
        {
          "name": "Indice du coût de construction de logements neufs au Burundi Juin 2027",
          "period": "Mensuelle",
          "deadline": "15/07/2027"
        }
      ]
    },
    {
      "month": "Juin 2027",
      "year": "2027",
      "publications": [
        {
          "name": "Indice des prix à la consommation (Taux d'inflation) Mai 2027",
          "period": "Mensuelle",
          "deadline": "15/06/2027"
        },
        {
          "name": "Indice des prix à la production agricole Mai 2027",
          "period": "Mensuelle",
          "deadline": "15/06/2027"
        },
        {
          "name": "Indice du coût de construction de logements neufs au Burundi Mai 2027",
          "period": "Mensuelle",
          "deadline": "15/06/2027"
        },
        {
          "name": "Les comptes nationaux trimestriels premier trimestre 2027",
          "period": "Trimestrielle",
          "deadline": "30/06/2027"
        }
      ]
    },
    {
      "month": "Mai 2027",
      "year": "2027",
      "publications": [
        {
          "name": "Indice des prix à la consommation (Taux d'inflation) Avril 2027",
          "period": "Mensuelle",
          "deadline": "15/05/2027"
        },
        {
          "name": "Indice harmonisé à la production (IHPI) premier trimestre 2027",
          "period": "Trimestrielle",
          "deadline": "15/05/2027"
        },
        {
          "name": "Indice du commerce extérieur (ICE) premier trimestre 2027",
          "period": "Trimestrielle",
          "deadline": "15/05/2027"
        },
        {
          "name": "Indice du chiffre d'affaire (ICA) premier trimestre 2027",
          "period": "Trimestrielle",
          "deadline": "15/05/2027"
        }
        ,
        {
          "name": "Bulletin du commerce extérieur premier trimestre 2027",
          "period": "Trimestrielle",
          "deadline": "15/05/2027"
        },
        {
          "name": "Bulletin de conjoncture premier trimestre 2027",
          "period": "Trimestrielle",
          "deadline": "15/05/2027"
        },
        {
          "name": "Note de conjoncture premier trimestre 2027",
          "period": "Trimestrielle",
          "deadline": "15/05/2027"
        },
        {
          "name": "Referentiel (mercuriale) des prix au Burundi premier trimestre 2027",
          "period": "Trimestrielle",
          "deadline": "15/05/2027"
        },
        {
          "name": "NewsStat premier trimestre 2027",
          "period": "Trimestrielle",
          "deadline": "15/05/2027"
        },
        {
          "name": "Indice des prix à la production agricole Avril 2027",
          "period": "Mensuelle",
          "deadline": "15/05/2027"
        },
        {
          "name": "Indice du coût de construction de logements neufs au Burundi Avril 2027",
          "period": "Mensuelle",
          "deadline": "15/05/2027"
        }
      ]
    },
    {
      "month": "Avril 2027",
      "year": "2027",
      "publications": [
        {
          "name": "Indice des prix à la consommation (Taux d'inflation) Mars 2027",
          "period": "Mensuelle",
          "deadline": "15/04/2027"
        },
        {
          "name": "Indice des prix à la production agricole Mars 2027",
          "period": "Mensuelle",
          "deadline": "15/04/2027"
        },
        {
          "name": "Indice du coût de construction de logements neufs au Burundi Mars 2027",
          "period": "Mensuelle",
          "deadline": "15/04/2027"
        }
      ]
    },
    {
      "month": "Mars 2027",
      "year": "2027",
      "publications": [
        {
          "name": "Indice des prix à la consommation (Taux d'inflation) Février 2027",
          "period": "Mensuelle",
          "deadline": "15/03/2027"
        },
        {
          "name": "Indice des prix à la production agricole Février 2027",
          "period": "Mensuelle",
          "deadline": "15/03/2027"
        },
        
        {
          "name": "Les comptes nationaux trimestriels quatrième trimestre 2026",
          "period": "Trimestrielle",
          "deadline": "31/03/2027"
        },
        {
          "name": "Indice du coût de construction de logements neufs au Burundi Février 2027",
          "period": "Mensuelle",
          "deadline": "15/03/2027"
        },
       
        {
          "name": "Annuaire statistique du Burundi 2025",
          "period": "Annuelle",
          "deadline": "15/03/2027"
        },
        {
          "name": "Indicateurs de Développement Humain Durable au Burundi 2025",
          "period": "Annuelle",
          "deadline": "15/03/2027"
        }
      ]
    },
    {
      "month": "Février 2027",
      "year": "2027",
      "publications": [
        {
          "name": "Indice des prix à la consommation (Taux d'inflation) Janvier 2027",
          "period": "Mensuelle",
          "deadline": "15/02/2027"
        },
        {
          "name": "Indice harmonisé à la production (IHPI) quatrième trimestre 2026",
          "period": "Trimestrielle",
          "deadline": "15/02/2027"
        },
        {
          "name": "Indice du commerce extérieur (ICE) quatrième trimestre 2026",
          "period": "Trimestrielle",
          "deadline": "15/02/2027"
        },
        {
          "name": "Indice du chiffre d'affaires (ICA) quatrième trimestre 2026",
          "period": "Trimestrielle",
          "deadline": "15/02/2027"
        },
        {
          "name": "Bulletin du commerce extérieur quatrième trimestre 2026",
          "period": "Trimestrielle",
          "deadline": "15/02/2027"
        },
        {
          "name": "Bulletin de conjoncture quatrième trimestre 2026",
          "period": "Trimestrielle",
          "deadline": "15/02/2027"
        },
        {
          "name": "Note de conjoncture quatrième trimestre 2026",
          "period": "Trimestrielle",
          "deadline": "15/02/2027"
        },
        {
          "name": "Referentiel (mercuriale) des prix au Burundi quatrième trimestre 2026",
          "period": "Trimestrielle",
          "deadline": "15/02/2027"
        },
        {
          "name": "NewsStat quatrième trimestre 2026",
          "period": "Trimestrielle",
          "deadline": "15/02/2027"
        },
        {
          "name": "Indice des prix à la production agricole Janvier 2027",
          "period": "Mensuelle",
          "deadline": "15/02/2027"
        },
        {
          "name": "Indice du coût de construction de logements neufs au Burundi Janvier 2027",
          "period": "Mensuelle",
          "deadline": "15/02/2027"
        },
        {
          "name": "Annuaire des Statistiques de l'Environnement 2025",
          "period": "Annuelle",
          "deadline": "15/02/2027"
        },
        {
          "name": "Parc Automobile 2025",
          "period": "Annuelle",
          "deadline": "15/02/2027"
        },
        {
          "name": "Tableau de Bord Social 2025",
          "period": "Annuelle",
          "deadline": "15/02/2027"
        },
        {
          "name": "Annuaire du Commerce Extérieur 2025",
          "period": "Annuelle",
          "deadline": "15/02/2027"
        },
        {
          "name": "Annuaire des Statistiques Agricoles 2025",
          "period": "Annuelle",
          "deadline": "15/02/2027"
        },
        {
          "name": "Bulletin Conjoncturel des Statistiques aux Frontières 2025",
          "period": "Annuelle",
          "deadline": "15/02/2027"
        },
        {
          "name": "Annuaire Statistique du Tourisme 2025",
          "period": "Annuelle",
          "deadline": "15/02/2027"
        },
        {
          "name": "Annuaire Statistique 2025",
          "period": "Annuelle",
          "deadline": "15/02/2027"
        },
        {
          "name": "Comptes de l'Energie 2025",
          "period": "Annuelle",
          "deadline": "15/02/2027"
        },
        {
          "name": "Indicateurs de Développement Humain Durable (DHD) 2025",
          "period": "Annuelle",
          "deadline": "15/02/2027"
        },
        {
          "name": "Cahiers de l'INSBU 2025",
          "period": "Annuelle",
          "deadline": "15/02/2027"
        },
        {
          "name": "Profil socio-économique 2025",
          "period": "Annuelle",
          "deadline": "15/02/2027"
        }
      ]
    },
    {
      "month": "Janvier 2027",
      "year": "2027",
      "publications": [
        {
          "name": "Indice des prix à la consommation (Taux d'inflation) Décembre 2026",
          "period": "Mensuelle",
          "deadline": "15/01/2027"
        },
        {
          "name": "Indice des prix à la production agricole Décembre 2026",
          "period": "Mensuelle",
          "deadline": "15/01/2027"
        },
        {
          "name": "Indice du coût de construction de logements neufs au Burundi Décembre 2026",
          "period": "Mensuelle",
          "deadline": "15/01/2027"
        }
       
      ]
    },
    {
      "month": "Décembre 2026",
      "year": "2026",
      "publications": [
        {
          "name": "Indice des prix à la consommation (Taux d'inflation) Novembre 2026",
          "period": "Mensuelle",
          "deadline": "15/12/2026"
        },
        {
          "name": "Indice des prix à la production agricole Novembre 2026",
          "period": "Mensuelle",
          "deadline": "15/12/2026"
        },
        {
          "name": "Indice du coût de construction de logements neufs au Burundi Novembre 2026",
          "period": "Mensuelle",
          "deadline": "15/12/2026"
        }
        ,
        {
          "name": "Les comptes nationaux trimestriels Troisieme trimestre 2026",
          "period": "Trimestrielle",
          "deadline": "31/12/2026"
        }
      ]
    },
    {
      "month": "Novembre 2026",
      "year": "2026",
      "publications": [
        {
          "name": "Indice des prix à la consommation (Taux d'inflation) Octobre 2026",
          "period": "Mensuelle",
          "deadline": "15/11/2026"
        },
        {
          "name": "Indice harmonisé à la production (IHPI) Troisieme trimestre 2026",
          "period": "Trimestrielle",
          "deadline": "15/11/2026"
        },
        {
          "name": "Indice du commerce extérieur (ICE) Troisieme trimestre 2026",
          "period": "Trimestrielle",
          "deadline": "15/11/2026"
        },
        {
          "name": "Indice du chiffre d'affaire (ICA) Troisieme trimestre 2026",
          "period": "Trimestrielle",
          "deadline": "15/11/2026"
        },
        {
          "name": "Bulletin du commerce extérieur Troisieme trimestre 2026",
          "period": "Trimestrielle",
          "deadline": "15/11/2026"
        },
        {
          "name": "Bulletin de conjoncture Troisieme trimestre 2026",
          "period": "Trimestrielle",
          "deadline": "15/11/2026"
        },
        {
          "name": "Note de conjoncture Troisieme trimestre 2026",
          "period": "Trimestrielle",
          "deadline": "15/11/2026"
        },
        {
          "name": "Referentiel (mercuriale) des prix au Burundi Troisieme trimestre 2026",
          "period": "Trimestrielle",
          "deadline": "15/11/2026"
        },
        {
          "name": "NewsStat Troisieme trimestre 2026",
          "period": "Trimestrielle",
          "deadline": "15/11/2026"
        },
        {
          "name": "Indice des prix à la production agricole Octobre 2026",
          "period": "Mensuelle",
          "deadline": "15/11/2026"
        },
        {
          "name": "Indice du coût de construction de logements neufs au Burundi Octobre 2026",
          "period": "Mensuelle",
          "deadline": "15/11/2026"
        }
      ]
    },
    {
      "month": "Octobre 2026",
      "year": "2026",
      "publications": [
        {
          "name": "Indice des prix à la consommation (Taux d'inflation) Septembre 2026",
          "period": "Mensuelle",
          "deadline": "15/10/2026"
        },
        {
          "name": "Indice des prix à la production agricole Septembre 2026",
          "period": "Mensuelle",
          "deadline": "15/10/2026"
        },
        {
          "name": "Indice du coût de construction de logements neufs au Burundi Septembre 2026",
          "period": "Mensuelle",
          "deadline": "15/10/2026"
        }
      ]
    },
    {
      "month": "Septembre 2026",
      "year": "2026",
      "publications": [
        {
          "name": "Indice des prix à la consommation (Taux d'inflation) Aout 2026",
          "period": "Mensuelle",
          "deadline": "15/09/2026"
        },
        {
          "name": "Indice des prix à la production agricole Aout 2026",
          "period": "Mensuelle",
          "deadline": "15/09/2026"
        },
        {
          "name": "Indice du coût de construction de logements neufs au Burundi Aout 2026",
          "period": "Mensuelle",
          "deadline": "15/09/2026"
        },
         {
          "name": "Les comptes nationaux trimestriels Deuxieme trimestre 2026",
          "period": "Trimestrielle",
          "deadline": "30/09/2026"
        }
      ]
    },
    {
      "month": "Août 2026",
      "year": "2026",
      "publications": [
        {
          "name": "Indice des prix à la consommation (Taux d'inflation) Juillet 2026",
          "period": "Mensuelle",
          "deadline": "15/08/2026"
        },
        {
          "name": "Indice harmonisé à la production (IHPI) Deuxieme trimestre 2026",
          "period": "Trimestrielle",
          "deadline": "15/08/2026"
        },
        {
          "name": "Indice du commerce extérieur (ICE) Deuxieme trimestre 2026",
          "period": "Trimestrielle",
          "deadline": "15/08/2026"
        },
        {
          "name": "Indice du chiffre d'affaire (ICA) Deuxieme trimestre 2026",
          "period": "Trimestrielle",
          "deadline": "15/08/2026"
        },
        
        {
          "name": "Bulletin du commerce extérieur Deuxieme trimestre 2026",
          "period": "Trimestrielle",
          "deadline": "15/08/2026"
        },
        {
          "name": "Bulletin de conjoncture Deuxieme trimestre 2026",
          "period": "Trimestrielle",
          "deadline": "15/08/2026"
        },
        {
          "name": "Note de conjoncture Deuxieme trimestre 2026",
          "period": "Trimestrielle",
          "deadline": "15/08/2026"
        },
        {
          "name": "Referentiel (mercuriale) des prix au Burundi Deuxieme trimestre 2026",
          "period": "Trimestrielle",
          "deadline": "15/08/2026"
        },
        {
          "name": "NewsStat Deuxieme trimestre 2026",
          "period": "Trimestrielle",
          "deadline": "15/08/2026"
        },
        {
          "name": "Indice des prix à la production agricole Juillet 2026",
          "period": "Mensuelle",
          "deadline": "15/08/2026"
        },
        {
          "name": "Indice du coût de construction de logements neufs au Burundi Juillet 2026",
          "period": "Mensuelle",
          "deadline": "15/08/2026"
        }
      ]
    },
    {
      "month": "Juillet 2026",
      "year": "2026",
      "publications": [
        {
          "name": "Indice des prix à la consommation (Taux d'inflation) Juin 2026",
          "period": "Mensuelle",
          "deadline": "15/07/2026"
        },
        {
          "name": "Indice des prix à la production agricole Juin 2026",
          "period": "Mensuelle",
          "deadline": "15/07/2026"
        },
        {
          "name": "Indice du coût de construction de logements neufs au Burundi Juin 2026",
          "period": "Mensuelle",
          "deadline": "15/07/2026"
        }
      ]
    },
    {
      "month": "Juin 2026",
      "year": "2026",
      "publications": [
        {
          "name": "Indice des prix à la consommation (Taux d'inflation) Mai 2026",
          "period": "Mensuelle",
          "deadline": "15/06/2026"
        },
        {
          "name": "Indice des prix à la production agricole Mai 2026",
          "period": "Mensuelle",
          "deadline": "15/06/2026"
        },
        {
          "name": "Indice du coût de construction de logements neufs au Burundi Mai 2026",
          "period": "Mensuelle",
          "deadline": "15/06/2026"
        },
         {
          "name": "Les comptes nationaux trimestriels premier trimestre 2026",
          "period": "Trimestrielle",
          "deadline": "30/06/2026"
        }
      ]
    },
    {
      "month": "Mai 2026",
      "year": "2026",
      "publications": [
        {
          "name": "Indice des prix à la consommation (Taux d'inflation) Avril 2026",
          "period": "Mensuelle",
          "deadline": "15/05/2026"
        },
        {
          "name": "Indice harmonisé à la production (IHPI) premier trimestre 2026",
          "period": "Trimestrielle",
          "deadline": "15/05/2026"
        },
        {
          "name": "Indice du commerce extérieur (ICE) premier trimestre 2026",
          "period": "Trimestrielle",
          "deadline": "15/05/2026"
        },
        {
          "name": "Indice du chiffre d'affaire (ICA) premier trimestre 2026",
          "period": "Trimestrielle",
          "deadline": "15/05/2026"
        },
      
        {
          "name": "Bulletin du commerce extérieur premier trimestre 2026",
          "period": "Trimestrielle",
          "deadline": "15/05/2026"
        },
        {
          "name": "Bulletin de conjoncture premier trimestre 2026",
          "period": "Trimestrielle",
          "deadline": "15/05/2026"
        },
        {
          "name": "Note de conjoncture premier trimestre 2026",
          "period": "Trimestrielle",
          "deadline": "15/05/2026"
        },
        {
          "name": "Referentiel (mercuriale) des prix au Burundi premier trimestre 2026",
          "period": "Trimestrielle",
          "deadline": "15/05/2026"
        },
        {
          "name": "NewsStat premier trimestre 2026",
          "period": "Trimestrielle",
          "deadline": "15/05/2026"
        },
        {
          "name": "Indice des prix à la production agricole Avril 2026",
          "period": "Mensuelle",
          "deadline": "15/05/2026"
        },
        {
          "name": "Indice du coût de construction de logements neufs au Burundi Avril 2026",
          "period": "Mensuelle",
          "deadline": "15/05/2026"
        }
      ]
    },
    {
      "month": "Avril 2026",
      "year": "2026",
      "publications": [
        {
          "name": "Indice des prix à la consommation (Taux d'inflation) Mars 2026",
          "period": "Mensuelle",
          "deadline": "15/04/2026"
        },
        {
          "name": "Indice des prix à la production agricole Mars 2026",
          "period": "Mensuelle",
          "deadline": "15/04/2026"
        },
        {
          "name": "Indice du coût de construction de logements neufs au Burundi Mars 2026",
          "period": "Mensuelle",
          "deadline": "15/04/2026"
        }
      ]
    },
    {
      "month": "Mars 2026",
      "year": "2026",
      "publications": [
        {
          "name": "Indice des prix à la consommation (Taux d'inflation) Février 2026",
          "period": "Mensuelle",
          "deadline": "15/03/2026"
        },
        {
          "name": "Indice des prix à la production agricole Février 2026",
          "period": "Mensuelle",
          "deadline": "15/03/2026"
        },
        {
          "name": "Indice du coût de construction de logements neufs au Burundi Février 2026",
          "period": "Mensuelle",
          "deadline": "15/03/2026"
        },
       
        {
          "name": "Annuaire statistique du Burundi 2024",
          "period": "Annuelle",
          "deadline": "15/03/2026"
        },
        {
          "name": "Indicateurs de Développement Humain Durable au Burundi 2024",
          "period": "Annuelle",
          "deadline": "15/03/2026"
        },
         {
          "name": "Les comptes nationaux trimestriels quatrième trimestre 2025",
          "period": "Trimestrielle",
          "deadline": "31/03/2026"
        },
      ]
    },
    {
      "month": "Février 2026",
      "year": "2026",
      "publications": [
        {
          "name": "Indice des prix à la consommation (Taux d'inflation) Janvier 2026",
          "period": "Mensuelle",
          "deadline": "15/02/2026"
        },
        {
          "name": "Indice harmonisé à la production (IHPI) quatrième trimestre 2025",
          "period": "Trimestrielle",
          "deadline": "15/02/2026"
        },
        {
          "name": "Indice du commerce extérieur (ICE) quatrième trimestre 2025",
          "period": "Trimestrielle",
          "deadline": "15/02/2026"
        },
        {
          "name": "Indice du chiffre d'affaires (ICA) quatrième trimestre 2025",
          "period": "Trimestrielle",
          "deadline": "15/02/2026"
        },
       
        {
          "name": "Bulletin du commerce extérieur quatrième trimestre 2025",
          "period": "Trimestrielle",
          "deadline": "15/02/2026"
        },
        {
          "name": "Bulletin de conjoncture quatrième trimestre 2025",
          "period": "Trimestrielle",
          "deadline": "15/02/2026"
        },
        {
          "name": "Note de conjoncture quatrième trimestre 2025",
          "period": "Trimestrielle",
          "deadline": "15/02/2026"
        },
        {
          "name": "Referentiel (mercuriale) des prix au Burundi quatrième trimestre 2025",
          "period": "Trimestrielle",
          "deadline": "15/02/2026"
        },
        {
          "name": "NewsStat quatrième trimestre 2025",
          "period": "Trimestrielle",
          "deadline": "15/02/2026"
        },
        {
          "name": "Indice des prix à la production agricole Janvier 2026",
          "period": "Mensuelle",
          "deadline": "15/02/2026"
        },
        {
          "name": "Indice du coût de construction de logements neufs au Burundi Janvier 2026",
          "period": "Mensuelle",
          "deadline": "15/02/2026"
        },
        {
          "name": "Annuaire des Statistiques de l'Environnement 2024",
          "period": "Annuelle",
          "deadline": "15/02/2026"
        },
        {
          "name": "Parc Automobile 2024",
          "period": "Annuelle",
          "deadline": "15/02/2026"
        },
        {
          "name": "Tableau de Bord Social 2024",
          "period": "Annuelle",
          "deadline": "15/02/2026"
        },
        {
          "name": "Annuaire du Commerce Extérieur 2024",
          "period": "Annuelle",
          "deadline": "15/02/2026"
        },
        {
          "name": "Annuaire des Statistiques Agricoles 2024",
          "period": "Annuelle",
          "deadline": "15/02/2026"
        },
        {
          "name": "Bulletin Conjoncturel des Statistiques aux Frontières 2024",
          "period": "Annuelle",
          "deadline": "15/02/2026"
        },
        {
          "name": "Annuaire Statistique du Tourisme 2024",
          "period": "Annuelle",
          "deadline": "15/02/2026"
        },
        {
          "name": "Annuaire Statistique 2024",
          "period": "Annuelle",
          "deadline": "15/02/2026"
        },
        {
          "name": "Comptes de l'Energie 2024",
          "period": "Annuelle",
          "deadline": "15/02/2026"
        },
        {
          "name": "Indicateurs de Développement Humain Durable (DHD) 2024",
          "period": "Annuelle",
          "deadline": "15/02/2026"
        },
        {
          "name": "Cahiers de l'INSBU 2024",
          "period": "Annuelle",
          "deadline": "15/02/2026"
        },
        {
          "name": "Profil socio-économique 2024",
          "period": "Annuelle",
          "deadline": "15/02/2026"
        }
      ]
    },
    {
      "month": "Janvier 2026",
      "year": "2026",
      "publications": [
        {
          "name": "Indice des prix à la consommation (Taux d'inflation) Décembre 2025",
          "period": "Mensuelle",
          "deadline": "15/01/2026"
        },
        {
          "name": "Indice des prix à la production agricole Décembre 2025",
          "period": "Mensuelle",
          "deadline": "15/01/2026"
        },
        {
          "name": "Indice du coût de construction de logements neufs au Burundi Décembre 2025",
          "period": "Mensuelle",
          "deadline": "15/01/2026"
        }
      ]
    },
    {
  "month": "Décembre 2025",
  "year": "2025",
  "publications": [
    {
      "name": "Indice des prix à la consommation (Taux d'inflation) Novembre 2025",
      "period": "Mensuelle",
      "deadline": "15/12/2025"
    },
    {
      "name": "Indice des prix à la production agricole Novembre 2025",
      "period": "Mensuelle",
      "deadline": "15/12/2025"
    },
    {
      "name": "Indice du coût de construction de logements neufs au Burundi Novembre 2025",
      "period": "Mensuelle",
      "deadline": "15/12/2025"
    },
    {
      "name": "Indice du commerce extérieur (ICE) Novembre 2025",
      "period": "Mensuelle",
      "deadline": "15/12/2025"
    }
  ]
},{
  "month": "Novembre 2025",
  "year": "2025",
  "publications": [
    {
      "name": "Indice des prix à la consommation (Taux d'inflation) Octobre 2025",
      "period": "Mensuelle",
      "deadline": "15/11/2025"
    },
    {
      "name": "Indice harmonisé à la production (IHPI) Troisieme trimestre 2025",
      "period": "Trimestrielle",
      "deadline": "15/11/2025"
    },
    {
      "name": "Indice du commerce extérieur (ICE) Octobre 2025",
      "period": "Mensuelle",
      "deadline": "15/11/2025"
    },
    {
      "name": "Indice du chiffre d'affaire (ICA) Troisieme trimestre 2025",
      "period": "Trimestrielle",
      "deadline": "15/11/2025"
    },
    {
      "name": "Les comptes nationaux trimestriels Troisieme trimestre 2025",
      "period": "Trimestrielle",
      "deadline": "15/11/2025"
    },
    {
      "name": "Bulletin du commerce extérieur Troisieme trimestre 2025",
      "period": "Trimestrielle",
      "deadline": "15/11/2025"
    },
    {
      "name": "Bulletin de conjoncture Troisieme trimestre 2025",
      "period": "Trimestrielle",
      "deadline": "15/11/2025"
    },
    {
      "name": "Note de conjoncture Troisieme trimestre 2025",
      "period": "Trimestrielle",
      "deadline": "15/11/2025"
    },
    {
      "name": "Referentiel (mercuriale) des prix au Burundi Troisieme trimestre 2025",
      "period": "Trimestrielle",
      "deadline": "15/11/2025"
    },
    {
      "name": "NewsStat Troisieme trimestre 2025",
      "period": "Trimestrielle",
      "deadline": "15/11/2025"
    },
    {
      "name": "Indice des prix à la production agricole Octobre 2025",
      "period": "Mensuelle",
      "deadline": "15/11/2025"
    },
    {
      "name": "Indice du coût de construction de logements neufs au Burundi Octobre 2025",
      "period": "Mensuelle",
      "deadline": "15/11/2025"
    }
  ]
},
{
  "month": "Octobre 2025",
  "year": "2025",
  "publications": [
    {
      "name": "Indice des prix à la consommation (Taux d'inflation) Septembre 2025",
      "period": "Mensuelle",
      "deadline": "15/10/2025"
    },
    {
      "name": "Indice des prix à la production agricole Septembre 2025",
      "period": "Mensuelle",
      "deadline": "15/10/2025"
    },
    {
      "name": "Indice du coût de construction de logements neufs au Burundi Septembre 2025",
      "period": "Mensuelle",
      "deadline": "15/10/2025"
    },
    {
      "name": "Indice du commerce extérieur (ICE) Septembre 2025",
      "period": "Mensuelle",
      "deadline": "15/10/2025"
    }
  ]
},
{
  "month": "Septembre 2025",
  "year": "2025",
  "publications": [
    {
      "name": "Indice des prix à la consommation (Taux d'inflation) Aout 2025",
      "period": "Mensuelle",
      "deadline": "15/08/2025"
    },
    {
      "name": "Indice des prix à la production agricole Aout 2025",
      "period": "Mensuelle",
      "deadline": "15/08/2025"
    },
    {
      "name": "Indice du coût de construction de logements neufs au Burundi Aout 2025",
      "period": "Mensuelle",
      "deadline": "15/08/2025"
    },
    {
      "name": "Indice du commerce extérieur (ICE) Aout 2025",
      "period": "Mensuelle",
      "deadline": "15/08/2025"
    }
  ]
},
{
  "month": "Août 2025",
  "year": "2025",
  "publications": [
    {
      "name": "Indice des prix à la consommation (Taux d'inflation) Avril 2025",
      "period": "Mensuelle",
      "deadline": "15/08/2025"
    },
    {
      "name": "Indice haromonisé à la production (IHPI) Deuxieme trimestre 2025",
      "period": "Trimestrielle",
      "deadline": "15/08/2025"
    },
    {
      "name": "Indice du commerce extérieur (ICE) Avril 2025",
      "period": "Mensuelle",
      "deadline": "15/08/2025"
    },
    {
      "name": "Indice du chiffre d'affaire (ICA) Deuxieme trimestre 2025",
      "period": "Trimestrielle",
      "deadline": "15/08/2025"
    },
    {
      "name": "Les comptes nationaux trimestriels Deuxieme trimestre 2025",
      "period": "Trimestrielle",
      "deadline": "15/08/2025"
    },
    {
      "name": "Bulletin du commerce extérieur Deuxieme trimestre 2025",
      "period": "Trimestrielle",
      "deadline": "15/08/2025"
    },
    {
      "name": "Bulletin de conjoncture Deuxieme trimestre 2025",
      "period": "Trimestrielle",
      "deadline": "15/08/2025"
    },
    {
      "name": "Note de conjoncture Deuxieme trimestre 2025",
      "period": "Trimestrielle",
      "deadline": "15/08/2025"
    },
    {
      "name": "Referentiel (mercuriale) des prix au Burundi Deuxieme trimestre 2025",
      "period": "Trimestrielle",
      "deadline": "15/08/2025"
    },
    {
      "name": "NewsStat Deuxieme trimestre 2025",
      "period": "Trimestrielle",
      "deadline": "15/08/2025"
    },
    {
      "name": "Indice des prix à la production agricole Juillet 2025",
      "period": "Mensuelle",
      "deadline": "15/08/2025"
    },
    {
      "name": "Indice du coût de construction de logements neufs au Burundi Juillet 2025",
      "period": "Mensuelle",
      "deadline": "15/08/2025"
    }
  ]
},
{
  "month": "Juillet 2025",
  "year": "2025",
  "publications": [
    {
      "name": "Indice des prix à la consommation (Taux d'inflation) Juin 2025",
      "period": "Mensuelle",
      "deadline": "15/07/2025"
    },
    {
      "name": "Indice des prix à la production agricole Juin 2025",
      "period": "Mensuelle",
      "deadline": "15/07/2025"
    },
    {
      "name": "Indice du coût de construction de logements neufs au Burundi Juin 2025",
      "period": "Mensuelle",
      "deadline": "15/07/2025"
    },
    {
      "name": "Indice du commerce extérieur (ICE) Juin 2025",
      "period": "Mensuelle",
      "deadline": "15/07/2025"
    }
  ]
},
{
  "month": "Juin 2025",
  "year": "2025",
  "publications": [
    {
      "name": "Indice des prix à la consommation (Taux d'inflation) Mai 2025",
      "period": "Mensuelle",
      "deadline": "15/06/2025"
    },
    {
      "name": "Indice des prix à la production agricole Mai 2025",
      "period": "Mensuelle",
      "deadline": "15/06/2025"
    },
    {
      "name": "Indice du coût de construction de logements neufs au Burundi Mai 2025",
      "period": "Mensuelle",
      "deadline": "15/06/2025"
    },
    {
      "name": "Indice du commerce extérieur (ICE) Mai 2025",
      "period": "Mensuelle",
      "deadline": "15/06/2025"
    }
  ]
},
{
      "month": "Mai 2025",
      "year": "2025",
      "publications": [
        {
          "name": "Indice des prix à la consommation (Taux d'inflation) Avril 2025",
          "period": "Mensuelle",
          "deadline": "15/05/2025"
        },
        {
          "name": "Indice harmonisé à la production (IHPI) premier trimestre 2025",
          "period": "Trimestrielle",
          "deadline": "15/05/2025"
        },
        {
          "name": "Indice du commerce extérieur (ICE) Avril 2025",
          "period": "Mensuelle",
          "deadline": "15/05/2025"
        },
        {
          "name": "Indice du chiffre d'affaire (ICA) premier trimestre 2025",
          "period": "Trimestrielle",
          "deadline": "15/05/2025"
        },
        {
          "name": "Les comptes nationaux trimestriels premier trimestre 2025",
          "period": "Trimestrielle",
          "deadline": "15/05/2025"
        },
        {
          "name": "Bulletin du commerce extérieur premier trimestre 2025",
          "period": "Trimestrielle",
          "deadline": "15/05/2025"
        },
        {
          "name": "Bulletin de conjoncture premier trimestre 2025",
          "period": "Trimestrielle",
          "deadline": "15/05/2025"
        },
        {
          "name": "Note de conjoncture premier trimestre 2025",
          "period": "Trimestrielle",
          "deadline": "15/05/2025"
        },
        {
          "name": "Referentiel (mercuriale) des prix au Burundi premier trimestre 2025",
          "period": "Trimestrielle",
          "deadline": "15/05/2025"
        },
        {
          "name": "NewsStat premier trimestre 2025",
          "period": "Trimestrielle",
          "deadline": "15/05/2025"
        },
        {
          "name": "Indice des prix à la production agricole Avril 2025",
          "period": "Mensuelle",
          "deadline": "15/05/2025"
        },
        {
          "name": "Indice du coût de construction de logements neufs au Burundi Avril 2025",
          "period": "Mensuelle",
          "deadline": "15/05/2025"
        }
      ]
    },
    {
      "month": "Avril 2025",
      "year": "2025",
      "publications": [
        {
          "name": "Indice des prix à la consommation (Taux d'inflation) Mars 2025",
          "period": "Mensuelle",
          "deadline": "15/04/2025"
        },
        {
          "name": "Indice des prix à la production agricole Mars 2025",
          "period": "Mensuelle",
          "deadline": "15/04/2025"
        },
        {
          "name": "Indice du coût de construction de logements neufs au Burundi Mars 2025",
          "period": "Mensuelle",
          "deadline": "15/04/2025"
        },
        {
          "name": "Indice du commerce extérieur (ICE) Mars 2025",
          "period": "Mensuelle",
          "deadline": "15/04/2025"
        }
      ]
    },
    {
      "month": "Mars 2025",
      "year": "2025",
      "publications": [
        {
          "name": "Indice des prix à la consommation (Taux d'inflation) Février 2025",
          "period": "Mensuelle",
          "deadline": "15/03/2025"
        },
        {
          "name": "Indice des prix à la production agricole Février 2025",
          "period": "Mensuelle",
          "deadline": "15/03/2025"
        },
        {
          "name": "Indice du coût de construction de logements neufs au Burundi Février 2025",
          "period": "Mensuelle",
          "deadline": "15/03/2025"
        },
        {
          "name": "Indice du commerce extérieur (ICE) Février 2025",
          "period": "Mensuelle",
          "deadline": "15/03/2025"
        },
        {
          "name": "Annuaire statistique du Burundi 2022",
          "period": "Annuelle",
          "deadline": "15/03/2025"
        },
        {
          "name": "Indicateurs de Développement Humain Durable au Burundi 2022",
          "period": "Annuelle",
          "deadline": "15/03/2025"
        }
      ]
    },
    {
      "month": "Février 2025",
      "year": "2025",
      "publications": [
        {
          "name": "Indice des prix à la consommation (Taux d'inflation) Janvier 2025",
          "period": "Mensuelle",
          "deadline": "15/02/2025"
        },
        {
          "name": "Indice harmonisé à la production (IHPI) quatrième trimestre 2024",
          "period": "Trimestrielle",
          "deadline": "15/02/2025"
        },
        {
          "name": "Indice du commerce extérieur (ICE) Janvier 2025",
          "period": "Mensuelle",
          "deadline": "15/02/2025"
        },
        {
          "name": "Indice du chiffre d'affaires (ICA) quatrième trimestre 2024",
          "period": "Trimestrielle",
          "deadline": "15/02/2025"
        },
        {
          "name": "Les comptes nationaux trimestriels quatrième trimestre 2024",
          "period": "Trimestrielle",
          "deadline": "15/02/2025"
        },
        {
          "name": "Bulletin du commerce extérieur quatrième trimestre 2024",
          "period": "Trimestrielle",
          "deadline": "15/02/2025"
        },
        {
          "name": "Bulletin de conjoncture quatrième trimestre 2024",
          "period": "Trimestrielle",
          "deadline": "15/02/2025"
        },
        {
          "name": "Note de conjoncture quatrième trimestre 2024",
          "period": "Trimestrielle",
          "deadline": "15/02/2025"
        },
        {
          "name": "Referentiel (mercuriale) des prix au Burundi quatrième trimestre 2024",
          "period": "Trimestrielle",
          "deadline": "15/02/2025"
        },
        {
          "name": "NewsStat quatrième trimestre 2024",
          "period": "Trimestrielle",
          "deadline": "15/02/2025"
        },
        {
          "name": "Indice des prix à la production agricole Janvier 2025",
          "period": "Mensuelle",
          "deadline": "15/02/2025"
        },
        {
          "name": "Indice du coût de construction de logements neufs au Burundi Janvier 2025",
          "period": "Mensuelle",
          "deadline": "15/02/2025"
        },
        {
          "name": "Annuaire des Statistiques de l'Environnement",
          "period": "Annuelle",
          "deadline": "15/02/2025"
        },
        {
          "name": "Parc Automobile",
          "period": "Annuelle",
          "deadline": "15/02/2025"
        },
        {
          "name": "Tableau de Bord Social",
          "period": "Annuelle",
          "deadline": "15/02/2025"
        },
        {
          "name": "Annuaire du Commerce Extérieur",
          "period": "Annuelle",
          "deadline": "15/02/2025"
        },
        {
          "name": "Annuaire des Statistiques Agricoles",
          "period": "Annuelle",
          "deadline": "15/02/2025"
        },
        {
          "name": "Bulletin Conjoncturel des Statistiques aux Frontières",
          "period": "Annuelle",
          "deadline": "15/02/2025"
        },
        {
          "name": "Annuaire Statistique du Tourisme",
          "period": "Annuelle",
          "deadline": "15/02/2025"
        },
        {
          "name": "Annuaire Statistique",
          "period": "Annuelle",
          "deadline": "15/02/2025"
        },
        {
          "name": "Comptes de l'Energie",
          "period": "Annuelle",
          "deadline": "15/02/2025"
        },
        {
          "name": "Indicateurs de Développement Humain Durable (DHD)",
          "period": "Annuelle",
          "deadline": "15/02/2025"
        },
        {
          "name": "Cahiers de l'INSBU",
          "period": "Annuelle",
          "deadline": "15/02/2025"
        },
        {
          "name": "Profil socio-économique",
          "period": "Annuelle",
          "deadline": "15/02/2025"
        }
      ]
    },
    {
      "month": "Janvier 2025",
      "year": "2025",
      "publications": [
        {
          "name": "Indice des prix à la consommation (Taux d'inflation) Décembre 2024",
          "period": "Mensuelle",
          "deadline": "15/01/2025"
        },
        {
          "name": "Indice des prix à la production agricole Décembre 2024",
          "period": "Mensuelle",
          "deadline": "15/01/2025"
        },
        {
          "name": "Indice du coût de construction de logements neufs au Burundi Décembre 2024",
          "period": "Mensuelle",
          "deadline": "15/01/2025"
        },
        {
          "name": "Indice du commerce extérieur (ICE) Décembre 2024",
          "period": "Mensuelle",
          "deadline": "15/01/2025"
        }
      ]
    },
    {
      "month": "Décembre 2024",
      "year": "2024",
      "publications": [
        {
          "name": "Indice des prix à la consommation (Taux d'inflation) Novembre 2024",
          "period": "Mensuelle",
          "deadline": "15/12/2024"
        },
        {
          "name": "Indice des prix à la production agricole Novembre 2024",
          "period": "Mensuelle",
          "deadline": "15/12/2024"
        },
        {
          "name": "Indice du coût de construction de logements neufs au Burundi Novembre 2024",
          "period": "Mensuelle",
          "deadline": "15/12/2024"
        },
        {
          "name": "Indice du commerce extérieur (ICE) Novembre 2024",
          "period": "Mensuelle",
          "deadline": "15/12/2024"
        }
      ]
    },
    {
      "month": "Novembre 2024",
      "year": "2024",
      "publications": [
        {
          "name": "Indice des prix à la consommation (Taux d'inflation) Octobre 2024",
          "period": "Mensuelle",
          "deadline": "15/11/2024"
        },
        {
          "name": "Indice des prix à la production agricole Octobre 2024",
          "period": "Mensuelle",
          "deadline": "15/11/2024"
        },
        {
          "name": "Indice du coût de construction de logements neufs au Burundi Octobre 2024",
          "period": "Mensuelle",
          "deadline": "15/11/2024"
        },
        {
          "name": "Indice du commerce extérieur (ICE) Octobre 2024",
          "period": "Mensuelle",
          "deadline": "15/11/2024"
        }
      ]
    },
    {
      "month": "Octobre 2024",
      "year": "2024",
      "publications": [
        {
          "name": "Indice des prix à la consommation (Taux d'inflation) Septembre 2024",
          "period": "Mensuelle",
          "deadline": "15/10/2024"
        },
        {
          "name": "Indice des prix à la production agricole Septembre 2024",
          "period": "Mensuelle",
          "deadline": "15/10/2024"
        },
        {
          "name": "Indice du coût de construction de logements neufs au Burundi Septembre 2024",
          "period": "Mensuelle",
          "deadline": "15/10/2024"
        },
        {
          "name": "Indice du commerce extérieur (ICE) Septembre 2024",
          "period": "Mensuelle",
          "deadline": "15/10/2024"
        },
        {
          "name": "Indice harmonisé à la production (IHPI) Troisième trimestre 2024",
          "period": "Trimestrielle",
          "deadline": "15/10/2024"
        },
        {
          "name": "Indice du chiffre d'affaires (ICA) Troisième trimestre 2024",
          "period": "Trimestrielle",
          "deadline": "15/10/2024"
        },
        {
          "name": "Les comptes nationaux trimestriels Troisième trimestre 2024",
          "period": "Trimestrielle",
          "deadline": "15/10/2024"
        },
        {
          "name": "Bulletin du commerce extérieur Troisième trimestre 2024",
          "period": "Trimestrielle",
          "deadline": "15/10/2024"
        },
        {
          "name": "Bulletin de conjoncture Troisième trimestre 2024",
          "period": "Trimestrielle",
          "deadline": "15/10/2024"
        },
        {
          "name": "Note de conjoncture Troisième trimestre 2024",
          "period": "Trimestrielle",
          "deadline": "15/10/2024"
        },
        {
          "name": "Referentiel (mercuriale) des prix au Burundi Troisième trimestre 2024",
          "period": "Trimestrielle",
          "deadline": "15/10/2024"
        },
        {
          "name": "NewsStat Troisième trimestre 2024",
          "period": "Trimestrielle",
          "deadline": "15/10/2024"
        }
      ]
    },
    {
      "month": "Septembre 2024",
      "year": "2024",
      "publications": [
        {
          "name": "Indice des prix à la consommation (Taux d'inflation) Août 2024",
          "period": "Mensuelle",
          "deadline": "15/09/2024"
        },
        {
          "name": "Indice des prix à la production agricole Août 2024",
          "period": "Mensuelle",
          "deadline": "15/09/2024"
        },
        {
          "name": "Indice du coût de construction de logements neufs au Burundi Août 2024",
          "period": "Mensuelle",
          "deadline": "15/09/2024"
        },
        {
          "name": "Indice du commerce extérieur (ICE) Août 2024",
          "period": "Mensuelle",
          "deadline": "15/09/2024"
        }
      ]
    },
    {
      "month": "Août 2024",
      "year": "2024",
      "publications": [
        {
          "name": "Indice des prix à la consommation (Taux d'inflation) Juillet 2024",
          "period": "Mensuelle",
          "deadline": "15/08/2024"
        },
        {
          "name": "Indice des prix à la production agricole Juillet 2024",
          "period": "Mensuelle",
          "deadline": "15/08/2024"
        },
        {
          "name": "Indice du coût de construction de logements neufs au Burundi Juillet 2024",
          "period": "Mensuelle",
          "deadline": "15/08/2024"
        },
        {
          "name": "Indice du commerce extérieur (ICE) Juillet 2024",
          "period": "Mensuelle",
          "deadline": "15/08/2024"
        }
      ]
    },
    {
      "month": "Juillet 2024",
      "year": "2024",
      "publications": [
        {
          "name": "Indice des prix à la consommation (Taux d'inflation) Juin 2024",
          "period": "Mensuelle",
          "deadline": "15/07/2024"
        },
        {
          "name": "Indice des prix à la production agricole Juin 2024",
          "period": "Mensuelle",
          "deadline": "15/07/2024"
        },
        {
          "name": "Indice du coût de construction de logements neufs au Burundi Juin 2024",
          "period": "Mensuelle",
          "deadline": "15/07/2024"
        },
        {
          "name": "Indice du commerce extérieur (ICE) Juin 2024",
          "period": "Mensuelle",
          "deadline": "15/07/2024"
        },
        {
          "name": "Indice harmonisé à la production (IHPI) Deuxième trimestre 2024",
          "period": "Trimestrielle",
          "deadline": "15/07/2024"
        },
        {
          "name": "Indice du chiffre d'affaires (ICA) Deuxième trimestre 2024",
          "period": "Trimestrielle",
          "deadline": "15/07/2024"
        },
        {
          "name": "Les comptes nationaux trimestriels Deuxième trimestre 2024",
          "period": "Trimestrielle",
          "deadline": "15/07/2024"
        },
        {
          "name": "Bulletin du commerce extérieur Deuxième trimestre 2024",
          "period": "Trimestrielle",
          "deadline": "15/07/2024"
        },
        {
          "name": "Bulletin de conjoncture Deuxième trimestre 2024",
          "period": "Trimestrielle",
          "deadline": "15/07/2024"
        },
        {
          "name": "Note de conjoncture Deuxième trimestre 2024",
          "period": "Trimestrielle",
          "deadline": "15/07/2024"
        },
        {
          "name": "Referentiel (mercuriale) des prix au Burundi Deuxième trimestre 2024",
          "period": "Trimestrielle",
          "deadline": "15/07/2024"
        },
        {
          "name": "NewsStat Deuxième trimestre 2024",
          "period": "Trimestrielle",
          "deadline": "15/07/2024"
        }
      ]
    },
    {
      "month": "Juin 2024",
      "year": "2024",
      "publications": [
        {
          "name": "Indice des prix à la consommation (Taux d'inflation) Mai 2024",
          "period": "Mensuelle",
          "deadline": "15/06/2024"
        },
        {
          "name": "Indice des prix à la production agricole Mai 2024",
          "period": "Mensuelle",
          "deadline": "15/06/2024"
        },
        {
          "name": "Indice du coût de construction de logements neufs au Burundi Mai 2024",
          "period": "Mensuelle",
          "deadline": "15/06/2024"
        },
        {
          "name": "Indice du commerce extérieur (ICE) Mai 2024",
          "period": "Mensuelle",
          "deadline": "15/06/2024"
        }
      ]
    },
    {
      "month": "Mai 2024",
      "year": "2024",
      "publications": [
        {
          "name": "Indice des prix à la consommation (Taux d'inflation) Avril 2024",
          "period": "Mensuelle",
          "deadline": "15/05/2024"
        },
        {
          "name": "Indice harmonisé à la production (IHPI) Premier trimestre 2024",
          "period": "Trimestrielle",
          "deadline": "15/05/2024"
        },
        {
          "name": "Indice du commerce extérieur (ICE) Avril 2024",
          "period": "Mensuelle",
          "deadline": "15/05/2024"
        },
        {
          "name": "Indice du chiffre d'affaire (ICA) Premier trimestre 2024",
          "period": "Trimestrielle",
          "deadline": "15/05/2024"
        },
        {
          "name": "Les comptes nationaux trimestriels Premier trimestre 2024",
          "period": "Trimestrielle",
          "deadline": "15/05/2024"
        },
        {
          "name": "Bulletin du commerce extérieur Premier trimestre 2024",
          "period": "Trimestrielle",
          "deadline": "15/05/2024"
        },
        {
          "name": "Bulletin de conjoncture Premier trimestre 2024",
          "period": "Trimestrielle",
          "deadline": "15/05/2024"
        },
        {
          "name": "Note de conjoncture Premier trimestre 2024",
          "period": "Trimestrielle",
          "deadline": "15/05/2024"
        },
        {
          "name": "Référentiel (mercuriale) des prix au Burundi Premier trimestre 2024",
          "period": "Trimestrielle",
          "deadline": "15/05/2024"
        },
        {
          "name": "NewsStat Premier trimestre 2024",
          "period": "Trimestrielle",
          "deadline": "15/05/2024"
        },
        {
          "name": "Indice des prix à la production agricole Avril 2024",
          "period": "Mensuelle",
          "deadline": "15/05/2024"
        },
        {
          "name": "Indice du coût de construction de logements neufs au Burundi Avril 2024",
          "period": "Mensuelle",
          "deadline": "15/05/2024"
        }
      ]
    },
    {
      "month": "Avril 2024",
      "year": "2024",
      "publications": [
        {
          "name": "Indice des prix à la consommation (Taux d'inflation) Mars 2024",
          "period": "Mensuelle",
          "deadline": "15/04/2024"
        },
        {
          "name": "Indice des prix à la production agricole Mars 2024",
          "period": "Mensuelle",
          "deadline": "15/04/2024"
        },
        {
          "name": "Indice du coût de construction de logements neufs au Burundi Mars 2024",
          "period": "Mensuelle",
          "deadline": "15/04/2024"
        },
        {
          "name": "Indice du commerce extérieur (ICE) Mars 2024",
          "period": "Mensuelle",
          "deadline": "15/04/2024"
        }
      ]
    },
    {
      "month": "Mars 2024",
      "year": "2024",
      "publications": [
        {
          "name": "Indice des prix à la consommation (Taux d'inflation) Février 2024",
          "period": "Mensuelle",
          "deadline": "15/03/2024"
        },
        {
          "name": "Indice des prix à la production agricole Février 2024",
          "period": "Mensuelle",
          "deadline": "15/03/2024"
        },
        {
          "name": "Indice du coût de construction de logements neufs au Burundi Février 2024",
          "period": "Mensuelle",
          "deadline": "15/03/2024"
        },
        {
          "name": "Indice du commerce extérieur (ICE) Février 2024",
          "period": "Mensuelle",
          "deadline": "15/03/2024"
        },
        {
          "name": "Annuaire statistique du Burundi 2022",
          "period": "Annuelle",
          "deadline": "15/03/2024"
        },
        {
          "name": "Indicateurs de Développement Humain Durable au Burundi 2022",
          "period": "Annuelle",
          "deadline": "15/03/2024"
        }
      ]
    },
    {
      "month": "Février 2024",
      "year": "2024",
      "publications": [
        {
          "name": "Indice des prix à la consommation (Taux d'inflation) Janvier 2024",
          "period": "Mensuelle",
          "deadline": "15/02/2024"
        },
        {
          "name": "Indice harmonisé à la production (IHPI) quatrième trimestre 2023",
          "period": "Trimestrielle",
          "deadline": "15/02/2024"
        },
        {
          "name": "Indice du commerce extérieur (ICE) Janvier 2024",
          "period": "Mensuelle",
          "deadline": "15/02/2024"
        },
        {
          "name": "Indice du chiffre d'affaires (ICA) quatrième trimestre 2023",
          "period": "Trimestrielle",
          "deadline": "15/02/2024"
        },
        {
          "name": "Les comptes nationaux trimestriels quatrième trimestre 2023",
          "period": "Trimestrielle",
          "deadline": "15/02/2024"
        },
        {
          "name": "Bulletin du commerce extérieur quatrième trimestre 2023",
          "period": "Trimestrielle",
          "deadline": "15/02/2024"
        },
        {
          "name": "Bulletin de conjoncture quatrième trimestre 2023",
          "period": "Trimestrielle",
          "deadline": "15/02/2024"
        },
        {
          "name": "Note de conjoncture quatrième trimestre 2023",
          "period": "Trimestrielle",
          "deadline": "15/02/2024"
        },
        {
          "name": "Referentiel (mercuriale) des prix au Burundi quatrième trimestre 2023",
          "period": "Trimestrielle",
          "deadline": "15/02/2024"
        },
        {
          "name": "NewsStat quatrième trimestre 2023",
          "period": "Trimestrielle",
          "deadline": "15/02/2024"
        },
        {
          "name": "Indice des prix à la production agricole Janvier 2024",
          "period": "Mensuelle",
          "deadline": "15/02/2024"
        },
        {
          "name": "Indice du coût de construction de logements neufs au Burundi Janvier 2024",
          "period": "Mensuelle",
          "deadline": "15/02/2024"
        },
        {
          "name": "Annuaire des Statistiques de l'Environnement",
          "period": "Annuelle",
          "deadline": "15/02/2024"
        },
        {
          "name": "Parc Automobile",
          "period": "Annuelle",
          "deadline": "15/02/2024"
        },
        {
          "name": "Tableau de Bord Social",
          "period": "Annuelle",
          "deadline": "15/02/2024"
        },
        {
          "name": "Annuaire du Commerce Extérieur",
          "period": "Annuelle",
          "deadline": "15/02/2024"
        },
        {
          "name": "Annuaire des Statistiques Agricoles",
          "period": "Annuelle",
          "deadline": "15/02/2024"
        },
        {
          "name": "Bulletin Conjoncturel des Statistiques aux Frontières",
          "period": "Annuelle",
          "deadline": "15/02/2024"
        },
        {
          "name": "Annuaire Statistique du Tourisme",
          "period": "Annuelle",
          "deadline": "15/02/2024"
        },
        {
          "name": "Annuaire Statistique",
          "period": "Annuelle",
          "deadline": "15/02/2024"
        },
        {
          "name": "Comptes de l'Energie",
          "period": "Annuelle",
          "deadline": "15/02/2024"
        },
        {
          "name": "Indicateurs de Développement Humain Durable (DHD)",
          "period": "Annuelle",
          "deadline": "15/02/2024"
        },
        {
          "name": "Cahiers de l'INSBU",
          "period": "Annuelle",
          "deadline": "15/02/2024"
        },
        {
          "name": "Profil socio-économique",
          "period": "Annuelle",
          "deadline": "15/02/2024"
        }
      ]
    },
    {
      "month": "Janvier 2024",
      "year": "2024",
      "publications": [
        {
          "name": "Indice des prix à la consommation (Taux d'inflation) Décembre 2023",
          "period": "Mensuelle",
          "deadline": "15/01/2024"
        },
        {
          "name": "Indice des prix à la production agricole Décembre 2023",
          "period": "Mensuelle",
          "deadline": "15/01/2024"
        },
        {
          "name": "Indice du coût de construction de logements neufs au Burundi Décembre 2023",
          "period": "Mensuelle",
          "deadline": "15/01/2024"
        },
        {
          "name": "Indice du commerce extérieur (ICE) Décembre 2023",
          "period": "Mensuelle",
          "deadline": "15/01/2024"
        }
      ]
    }
  ];
  function getMonthNumber(monthName) {
    const months = {
      'janvier': 0, 'février': 1, 'mars': 2, 'avril': 3, 'mai': 4, 'juin': 5,
      'juillet': 6, 'août': 7, 'septembre': 8, 'octobre': 9, 'novembre': 10, 'décembre': 11
    };
    return months[monthName.toLowerCase().split(' ')[0]]; 
  }

  const [typeFilter, setTypeFilter] = useState('Tous');
  const [monthFilter, setMonthFilter] = useState('Tous');
  const [yearFilter, setYearFilter] = useState('Tous');
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [showFilters, setShowFilters] = useState(true);
  const [showHelp, setShowHelp] = useState(false);

  const uniqueMonthsChronological = useMemo(() => {
    return [...new Set(data.map(item => item.month))]
      .sort((a, b) => {
        const [monthNameA, yearA] = a.split(' ');
        const [monthNameB, yearB] = b.split(' ');
        const dateA = new Date(parseInt(yearA), getMonthNumber(monthNameA), 1);
        const dateB = new Date(parseInt(yearB), getMonthNumber(monthNameB), 1);
        return dateA - dateB;
      });
  }, [data]);

  const uniqueYears = useMemo(() => {
    return [...new Set(data.map(item => item.year))].sort();
  }, [data]);

  const getMonthsForYearFilter = (selectedYear) => {
    if (selectedYear === 'Tous') {
      return uniqueMonthsChronological;
    } else {
      return uniqueMonthsChronological
        .filter(month => month.includes(selectedYear))
        .sort((a, b) => {
          const [monthNameA] = a.split(' ');
          const [monthNameB] = b.split(' ');
          return getMonthNumber(monthNameA) - getMonthNumber(monthNameB);
        });
    }
  };

  const isDeadlinePassed = (deadline) => {
    const [day, month, year] = deadline.split('/').map(Number);
    const deadlineDate = new Date(year, month - 1, day);
    const today = new Date();
    today.setHours(0, 0, 0, 0); 
    deadlineDate.setHours(0, 0, 0, 0); 
    return deadlineDate < today;
  };

  const filteredData = useMemo(() => {
    let filteredMonths = data;

    if (yearFilter !== 'Tous') {
      filteredMonths = filteredMonths.filter(monthData => monthData.year === yearFilter);
    }

    if (monthFilter !== 'Tous') {
      filteredMonths = filteredMonths.filter(monthData => monthData.month === monthFilter);
    }
    return filteredMonths
      .map(monthData => ({
        ...monthData,
        publications: monthData.publications.filter(pub =>
          (typeFilter === 'Tous' || pub.period === typeFilter) &&
          (searchTerm === '' ||
            pub.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
            pub.period.toLowerCase().includes(searchTerm.toLowerCase()) ||
            pub.deadline.includes(searchTerm))
        )
      }))
      .filter(monthData => monthData.publications.length > 0); 

  }, [
    data,
    typeFilter,
    monthFilter,
    yearFilter,
    searchTerm
  ]);

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedData = filteredData.slice(startIndex, endIndex);
  const pageCount = Math.ceil(filteredData.length / itemsPerPage);

  const resetFilters = () => {
    setTypeFilter('Tous');
    setSearchTerm('');
    setMonthFilter('Tous');
    setYearFilter('Tous');
    setCurrentPage(1);
  };


  const goToPreviousMonth = () => {
    let targetMonth = monthFilter;
    let targetYear = yearFilter;

    if (monthFilter === 'Tous' && yearFilter === 'Tous') {
      targetMonth = uniqueMonthsChronological[0];
      targetYear = targetMonth.split(' ')[1];
    } else if (monthFilter === 'Tous' && yearFilter !== 'Tous') {

      const monthsInFilteredYear = uniqueMonthsChronological.filter(m => m.includes(yearFilter));
      if (monthsInFilteredYear.length > 0) {
        targetMonth = monthsInFilteredYear[0];
        targetYear = yearFilter; 
      }
    }

    const currentIndex = uniqueMonthsChronological.indexOf(targetMonth);

    if (currentIndex > 0) {
      const prevMonth = uniqueMonthsChronological[currentIndex - 1];
      setMonthFilter(prevMonth);
      setYearFilter(prevMonth.split(' ')[1]);
      setCurrentPage(1);
    } else {
      console.log("Already at the earliest month.");
    }
  };

  const goToNextMonth = () => {
    let targetMonth = monthFilter;
    let targetYear = yearFilter;

   
    if (monthFilter === 'Tous' && yearFilter === 'Tous') {
      targetMonth = uniqueMonthsChronological[uniqueMonthsChronological.length - 1];
      targetYear = targetMonth.split(' ')[1];
    } else if (monthFilter === 'Tous' && yearFilter !== 'Tous') {
     
      const monthsInFilteredYear = uniqueMonthsChronological.filter(m => m.includes(yearFilter));
      if (monthsInFilteredYear.length > 0) {
        targetMonth = monthsInFilteredYear[monthsInFilteredYear.length - 1];
        targetYear = yearFilter; 
      }
    }

    const currentIndex = uniqueMonthsChronological.indexOf(targetMonth);

    if (currentIndex < uniqueMonthsChronological.length - 1) {
      const nextMonth = uniqueMonthsChronological[currentIndex + 1];
      setMonthFilter(nextMonth);
      setYearFilter(nextMonth.split(' ')[1]);
      setCurrentPage(1);
    } else {
      console.log("Already at the latest month.");
    }
  };

  
  useEffect(() => {
    setCurrentPage(1);
  }, [typeFilter, monthFilter, yearFilter, searchTerm, itemsPerPage]);

  return (
    <div style={{ backgroundColor: '#f5f5f5', minHeight: '100vh' }}>
      <NavigationBar />
      <br />
      <Box sx={{ margin: 3 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography variant="h5" gutterBottom sx={{ fontFamily: "'PT Sans', sans-serif", fontWeight: 'bold' }}>
            <CalendarMonthIcon sx={{ verticalAlign: 'middle', mr: 1 }} />
            Calendrier de diffusion 2024 - 2025
          </Typography>
        
          <Box>
            <Tooltip title="Mois précédent">
              <IconButton onClick={goToPreviousMonth} color="primary" sx={{ mr: 1 }}>
                <Typography variant="button" sx={{ fontSize: '1rem', mr: 0.5 }}> {'<'} </Typography> Précédent
              </IconButton>
            </Tooltip>
      
            <Tooltip title="Mois suivant">
              <IconButton onClick={goToNextMonth} color="primary" sx={{ mr: 1 }}>
                Suivant <Typography variant="button" sx={{ fontSize: '1rem', ml: 0.5 }}> {'>'} </Typography>
              </IconButton>
            </Tooltip>
            <Tooltip title={showFilters ? "Masquer les filtres" : "Afficher les filtres"}>
              <IconButton onClick={() => setShowFilters(!showFilters)} color="primary" sx={{ mr: 1 }}>
                {showFilters ? <FilterAltOffIcon /> : <FilterAltIcon />}
              </IconButton>
            </Tooltip>
            <Tooltip title="Aide">
              <IconButton onClick={() => setShowHelp(!showHelp)} color="info">
                <InfoIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
         <Typography variant="body1" paragraph style={{ marginBottom: '30px', fontSize: '1.1rem' }}>
              Découvrez le calendrier de diffusion des publications statistiques de l'INSBU de  2024 - 2027.
          </Typography>

        <Collapse in={showHelp} sx={{ mb: 2 }}>
          <Alert severity="info" onClose={() => setShowHelp(false)}>
            <strong>Comment utiliser ce calendrier :</strong>
            <ul>
              <li>Au chargement, le calendrier affiche <strong>toutes les publications</strong> par défaut.</li>
              <li>Utilisez les boutons <strong>Précédent</strong> et <strong>Suivant</strong> pour naviguer entre les mois.</li>
              <li>Utilisez les <strong>filtres</strong> pour affiner votre recherche par type de publication, mois, ou année.</li>
              <li>La <strong>barre de recherche</strong> vous permet de trouver des publications par nom, période ou date.</li>
              <li>Les dates en <PastDeadlineChip label="rouge" size="small" /> sont passées, celles en <UpcomingDeadlineChip label="vert" size="small" /> sont à venir.</li>
             
            </ul>
          </Alert>
        </Collapse>

        <Collapse in={showFilters}>
         
          <Grid container spacing={2} sx={{ mb: 3 }}>
                <Grid item xs={12} md={2}>
              <FormControl fullWidth>
                <InputLabel id="year-filter-label">Année</InputLabel>
                <Select
                  labelId="year-filter-label"
                  value={yearFilter}
                  label="Année"
                  onChange={(e) => {
                    const newYear = e.target.value;
                    setYearFilter(newYear);
                    setMonthFilter('Tous');
                  }}
                >
                  <MenuItem value="Tous">Toutes les années</MenuItem>
                  {uniqueYears.map(year => (
                    <MenuItem key={year} value={year}>{year}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
             <Grid item xs={12} md={2}>
              <FormControl fullWidth>
                <InputLabel id="month-filter-label">Mois</InputLabel>
                <Select
                  labelId="month-filter-label"
                  value={monthFilter}
                  label="Mois"
                  onChange={(e) => {
                    const newMonth = e.target.value;
                    setMonthFilter(newMonth);
                    // Update year filter when a specific month is selected
                    if (newMonth !== 'Tous') {
                      const yearFromMonth = newMonth.split(' ')[1];
                      setYearFilter(yearFromMonth);
                    } else if (yearFilter !== 'Tous') {
                      // If 'Tous les mois' is selected but a year is already filtered, keep that year
                    } else {
                      setYearFilter('Tous');
                    }
                  }}
                >
                  <MenuItem value="Tous">Tous les mois</MenuItem>
                  {getMonthsForYearFilter(yearFilter).map(month => (
                    <MenuItem key={month} value={month}>{month}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={2}>
              <FormControl fullWidth>
                <InputLabel id="type-filter-label">Type de publication</InputLabel>
                <Select
                  labelId="type-filter-label"
                  value={typeFilter}
                  label="Type de publication"
                  onChange={(e) => setTypeFilter(e.target.value)}
                >
                  <MenuItem value="Tous">Tous les types</MenuItem>
                  <MenuItem value="Mensuelle">Mensuelle</MenuItem>
                  <MenuItem value="Trimestrielle">Trimestrielle</MenuItem>
                  <MenuItem value="Annuelle">Annuelle</MenuItem>
                </Select>
              </FormControl>
            </Grid>
              <Grid item xs={12} md={4}>
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Rechercher une publication, une période ou une date..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          sx={{ mb: 2 }}
          InputProps={{
            startAdornment: <SearchIcon sx={{ color: 'action.active', mr: 1 }} />,
          }}
        />
        </Grid>
           <Grid item xs={12} md={2}>
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={resetFilters}
                  sx={{ height: '80%' }}
               
                >
                  Réinitialiser 
                </Button>
             </Grid>
          </Grid>
        </Collapse>

        {/* Filter summary */}
        {(typeFilter !== 'Tous' || monthFilter !== 'Tous' || yearFilter !== 'Tous' || searchTerm) && (
          <Alert severity="info" sx={{ mb: 2 }}>
            Filtres actifs :
            {typeFilter !== 'Tous' && <Chip label={`Type: ${typeFilter}`} size="small" sx={{ ml: 1 }} />}
            {searchTerm && <Chip label={`Recherche: "${searchTerm}"`} size="small" sx={{ ml: 1 }} />}
            {yearFilter !== 'Tous' && <Chip label={`Année: ${yearFilter}`} size="small" sx={{ ml: 1 }} />}
            {monthFilter !== 'Tous' && <Chip label={`Mois: ${monthFilter}`} size="small" sx={{ ml: 1 }} />}
            {(typeFilter === 'Tous' && monthFilter === 'Tous' && yearFilter === 'Tous' && !searchTerm) && (
              <Chip label="Vue: Toutes les publications" size="small" sx={{ ml: 1 }} />
            )}
            <Button size="small" onClick={resetFilters} sx={{ ml: 1 }}>
              Tout effacer
            </Button>
          </Alert>
        )}

        {/* Results */}
        <Typography variant="subtitle1" sx={{ mb: 1 }}>
          {filteredData.length > 0 ? (
            `Affichage de ${startIndex + 1} à ${Math.min(endIndex, filteredData.length)} sur ${filteredData.length} résultats`
          ) : (
            "Aucun résultat trouvé avec les filtres actuels"
          )}
        </Typography>

        <TableContainer component={Paper} sx={{ mb: 4, maxHeight: 'calc(200vh - 400px)', overflow: 'auto' }}>
          <Table size="small" aria-label="calendrier de diffusion" stickyHeader>
            <TableHead>
              <TableRow>
                <HeaderCell>Mois</HeaderCell>
                <HeaderCell>Publications</HeaderCell>
                <HeaderCell>Période de référence</HeaderCell>
                <HeaderCell>Délais de publication</HeaderCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedData.length > 0 ? (
                paginatedData.map((monthData, index) => (
                  <React.Fragment key={index}>
                    {monthData.publications.map((pub, pubIndex) => (
                      <TableRow
                        key={`${index}-${pubIndex}`}
                        sx={{
                          '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.04)' },
                          // Suppression de la logique de mise en évidence du mois en cours
                          backgroundColor: 'inherit'
                        }}
                      >
                        {pubIndex === 0 ? (
                          <TableCell
                            rowSpan={monthData.publications.length}
                            sx={{
                              verticalAlign: 'top',
                              fontWeight: 'bold',
                              position: 'sticky',
                              left: 0,
                              // Suppression de la logique de mise en évidence du mois en cours
                              backgroundColor: 'inherit',
                              zIndex: 0
                            }}
                          >
                            {monthData.month}
                            {/* Chip "En cours" supprimée */}
                          </TableCell>
                        ) : null}
                        <TableCell>{pub.name}</TableCell>
                        <TableCell>{pub.period}</TableCell>
                        <TableCell>
                          {isDeadlinePassed(pub.deadline) ? (
                            <PastDeadlineChip label={pub.deadline} size="small" />
                          ) : (
                            <UpcomingDeadlineChip label={pub.deadline} size="small" />
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                  </React.Fragment>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={4} align="center" sx={{ py: 4 }}>
                    <Typography variant="body1" color="textSecondary">
                      Aucune donnée disponible avec les filtres sélectionnés
                    </Typography>
                    <Button onClick={resetFilters} sx={{ mt: 2 }}>
                      Réinitialiser les filtres
                    </Button>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Pagination and items per page selection */}
        {filteredData.length > 0 && (
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 2 }}>
            <FormControl sx={{ minWidth: 120 }} size="small">
              <InputLabel>Lignes par page</InputLabel>
              <Select
                value={itemsPerPage}
                label="Lignes par page"
                onChange={(e) => setItemsPerPage(e.target.value)}
              >
                <MenuItem value={5}>5</MenuItem>
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={20}>20</MenuItem>
                <MenuItem value={50}>50</MenuItem>
                <MenuItem value={100}>100</MenuItem>
              </Select>
            </FormControl>

            <Pagination
              count={pageCount}
              page={currentPage}
              onChange={(event, value) => setCurrentPage(value)}
              color="primary"
              showFirstButton
              showLastButton
            />

            <Typography variant="body2">
              Page {currentPage} sur {pageCount}
            </Typography>
          </Box>
        )}
      </Box>
      <Footer />
    </div>
  );
};

export default CalendarTable;